import { CullMode } from "../../../RenderEngine/RenderEnum/CullMode";
import { GLSLCodeGenerator } from "../../../RenderEngine/RenderShader/GLSLCodeGenerator";
import { Shader3D } from "../../../RenderEngine/RenderShader/Shader3D";
import { RenderStateContext } from "../../../RenderEngine/RenderStateContext";
import { CommandEncoder } from "../../../layagl/CommandEncoder";
import { LayaGL } from "../../../layagl/LayaGL";
import { RenderState } from "../../RenderModuleData/Design/RenderState";
import { WebGLEngine } from "./WebGLEngine";
import { GPUEngineStatisticsInfo } from "../../../RenderEngine/RenderEnum/RenderStatInfo";
import { Config } from "../../../../Config";
import { WebGLRenderContext3D } from "../3DRenderPass/WebGLRenderContext3D";
export class WebGLShaderInstance {
    constructor() {
        this._cacheShaerVariable = {};
        this._uploadMark = -1;
        this._uploadRenderType = -1;
        this._additionUniformParamsMaps = new Map();
        this._additionShaderData = new Map();
    }
    _serializeShader() {
        return null;
    }
    _deserialize(buffer) {
        return false;
    }
    get complete() {
        return this._renderShaderInstance._complete;
    }
    _create(shaderProcessInfo, shaderPass) {
        let useMaterial = Config.matUseUBO;
        Config.matUseUBO = (!shaderProcessInfo.is2D) && Config.matUseUBO;
        let shaderObj = GLSLCodeGenerator.GLShaderLanguageProcess3D(shaderProcessInfo.defineString, shaderProcessInfo.attributeMap, shaderProcessInfo.uniformMap, shaderProcessInfo.vs, shaderProcessInfo.ps);
        this._renderShaderInstance = WebGLEngine.instance.createShaderInstance(shaderObj.vs, shaderObj.fs, shaderProcessInfo.attributeMap);
        Config.matUseUBO = useMaterial;
        if (WebGLEngine._lastShaderError) {
            console.warn(`[ShaderCompile]Error compiling shader '${shaderPass._owner._owner.name}' (pipelineMode=${shaderPass.pipelineMode})\n`, WebGLEngine._lastShaderError);
        }
        if (this._renderShaderInstance._complete) {
            this._shaderPass = shaderPass.moduleData;
            shaderProcessInfo.is2D ? this._create2D() : this._create3D();
        }
    }
    _create3D() {
        this._sceneUniformParamsMap = new CommandEncoder();
        this._cameraUniformParamsMap = new CommandEncoder();
        this._spriteUniformParamsMap = new CommandEncoder();
        this._materialUniformParamsMap = new CommandEncoder();
        let context = WebGLRenderContext3D._instance;
        let preDrawUniforms = context._preDrawUniformMaps;
        let preDrawParams = [];
        for (let key of preDrawUniforms) {
            let params = LayaGL.renderDeviceFactory.createGlobalUniformMap(key);
            preDrawParams.push(params);
        }
        const cameraParams = LayaGL.renderDeviceFactory.createGlobalUniformMap("BaseCamera");
        let i, n;
        let data = this._renderShaderInstance.getUniformMap();
        for (i = 0, n = data.length; i < n; i++) {
            let one = data[i];
            if (preDrawParams.find((params) => {
                return params.hasPtrID(one.dataOffset);
            })) {
                this._sceneUniformParamsMap.addShaderUniform(one);
            }
            else if (cameraParams.hasPtrID(one.dataOffset)) {
                this._cameraUniformParamsMap.addShaderUniform(one);
            }
            else if (this.hasSpritePtrID(one.dataOffset)) {
                this._spriteUniformParamsMap.addShaderUniform(one);
            }
            else if (this._hasAdditionShaderData(one.dataOffset)) {
                let str = this._hasAdditionShaderData(one.dataOffset);
                if (!this._additionUniformParamsMaps.get(str)) {
                    let commandEncoder = new CommandEncoder();
                    this._additionUniformParamsMaps.set(str, commandEncoder);
                }
                this._additionUniformParamsMaps.get(str).addShaderUniform(one);
            }
            else {
                this._materialUniformParamsMap.addShaderUniform(one);
            }
        }
    }
    _create2D() {
        this._sprite2DUniformParamsMap = new CommandEncoder();
        this._materialUniformParamsMap = new CommandEncoder();
        this._sceneUniformParamsMap = new CommandEncoder();
        const sceneParms = LayaGL.renderDeviceFactory.createGlobalUniformMap("Sprite2DGlobal");
        let i, n;
        let data = this._renderShaderInstance.getUniformMap();
        for (i = 0, n = data.length; i < n; i++) {
            let one = data[i];
            if (this.hasSpritePtrID(one.dataOffset)) {
                this._sprite2DUniformParamsMap.addShaderUniform(one);
            }
            else if (sceneParms.hasPtrID(one.dataOffset)) {
                this._sceneUniformParamsMap.addShaderUniform(one);
            }
            else {
                this._materialUniformParamsMap.addShaderUniform(one);
            }
        }
    }
    hasSpritePtrID(dataOffset) {
        let commap = this._shaderPass.nodeCommonMap;
        if (!commap) {
            return false;
        }
        else {
            for (let i = 0, n = commap.length; i < n; i++) {
                if (LayaGL.renderDeviceFactory.createGlobalUniformMap(commap[i]).hasPtrID(dataOffset))
                    return true;
            }
            return false;
        }
    }
    _hasAdditionShaderData(dataOffset) {
        let additionShaderData = this._shaderPass.additionShaderData;
        if (!additionShaderData) {
            return null;
        }
        else {
            for (let i = 0, n = additionShaderData.length; i < n; i++) {
                if (LayaGL.renderDeviceFactory.createGlobalUniformMap(additionShaderData[i]).hasPtrID(dataOffset))
                    return additionShaderData[i];
            }
        }
        return null;
    }
    _disposeResource() {
        this._renderShaderInstance.destroy();
        this._sceneUniformParamsMap = null;
        this._cameraUniformParamsMap = null;
        this._spriteUniformParamsMap = null;
        this._materialUniformParamsMap = null;
        this._sprite2DUniformParamsMap = null;
        this._uploadMaterial = null;
        this._uploadRender = null;
        this._uploadCameraShaderValue = null;
        this._uploadScene = null;
        this._additionShaderData = null;
    }
    bind() {
        return this._renderShaderInstance.bind();
    }
    uploadUniforms(shaderUniform, shaderDatas, uploadUnTexture) {
        WebGLEngine.instance._addStatisticsInfo(GPUEngineStatisticsInfo.C_UniformBufferUploadCount, WebGLEngine.instance.uploadUniforms(this._renderShaderInstance, shaderUniform, shaderDatas, uploadUnTexture));
    }
    uploadRenderStateBlendDepth(shaderDatas) {
        if ((this._shaderPass).statefirst)
            this.uploadRenderStateBlendDepthByShader(shaderDatas);
        else
            this.uploadRenderStateBlendDepthByMaterial(shaderDatas);
    }
    uploadRenderStateBlendDepthByShader(shaderDatas) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7;
        var datas = shaderDatas._data;
        var renderState = (this._shaderPass).renderState;
        var depthWrite = (_b = ((_a = renderState.depthWrite) !== null && _a !== void 0 ? _a : datas[Shader3D.DEPTH_WRITE])) !== null && _b !== void 0 ? _b : RenderState.Default.depthWrite;
        RenderStateContext.setDepthMask(depthWrite);
        var depthTest = (_d = ((_c = renderState.depthTest) !== null && _c !== void 0 ? _c : datas[Shader3D.DEPTH_TEST])) !== null && _d !== void 0 ? _d : RenderState.Default.depthTest;
        if (depthTest == RenderState.DEPTHTEST_OFF)
            RenderStateContext.setDepthTest(false);
        else {
            RenderStateContext.setDepthTest(true);
            RenderStateContext.setDepthFunc(depthTest);
        }
        var stencilWrite = (_f = ((_e = renderState.stencilWrite) !== null && _e !== void 0 ? _e : datas[Shader3D.STENCIL_WRITE])) !== null && _f !== void 0 ? _f : RenderState.Default.stencilWrite;
        var stencilTest = (_h = ((_g = renderState.stencilTest) !== null && _g !== void 0 ? _g : datas[Shader3D.STENCIL_TEST])) !== null && _h !== void 0 ? _h : RenderState.Default.stencilTest;
        RenderStateContext.setStencilMask(stencilWrite);
        if (stencilWrite) {
            var stencilOp = (_k = ((_j = renderState.stencilOp) !== null && _j !== void 0 ? _j : datas[Shader3D.STENCIL_Op])) !== null && _k !== void 0 ? _k : RenderState.Default.stencilOp;
            RenderStateContext.setstencilOp(stencilOp.x, stencilOp.y, stencilOp.z);
        }
        if (stencilTest == RenderState.STENCILTEST_OFF) {
            RenderStateContext.setStencilTest(false);
        }
        else {
            var stencilRef = (_m = ((_l = renderState.stencilRef) !== null && _l !== void 0 ? _l : datas[Shader3D.STENCIL_Ref])) !== null && _m !== void 0 ? _m : RenderState.Default.stencilRef;
            RenderStateContext.setStencilTest(true);
            RenderStateContext.setStencilFunc(stencilTest, stencilRef);
        }
        var blend = (_p = ((_o = renderState.blend) !== null && _o !== void 0 ? _o : datas[Shader3D.BLEND])) !== null && _p !== void 0 ? _p : RenderState.Default.blend;
        switch (blend) {
            case RenderState.BLEND_DISABLE:
                RenderStateContext.setBlend(false);
                break;
            case RenderState.BLEND_ENABLE_ALL:
                var blendEquation = (_r = ((_q = renderState.blendEquation) !== null && _q !== void 0 ? _q : datas[Shader3D.BLEND_EQUATION])) !== null && _r !== void 0 ? _r : RenderState.Default.blendEquation;
                var srcBlend = (_t = ((_s = renderState.srcBlend) !== null && _s !== void 0 ? _s : datas[Shader3D.BLEND_SRC])) !== null && _t !== void 0 ? _t : RenderState.Default.srcBlend;
                var dstBlend = (_v = ((_u = renderState.dstBlend) !== null && _u !== void 0 ? _u : datas[Shader3D.BLEND_DST])) !== null && _v !== void 0 ? _v : RenderState.Default.dstBlend;
                RenderStateContext.setBlend(true);
                RenderStateContext.setBlendEquation(blendEquation);
                RenderStateContext.setBlendFunc(srcBlend, dstBlend);
                break;
            case RenderState.BLEND_ENABLE_SEPERATE:
                var blendEquationRGB = (_x = ((_w = renderState.blendEquationRGB) !== null && _w !== void 0 ? _w : datas[Shader3D.BLEND_EQUATION_RGB])) !== null && _x !== void 0 ? _x : RenderState.Default.blendEquationRGB;
                var blendEquationAlpha = (_z = ((_y = renderState.blendEquationAlpha) !== null && _y !== void 0 ? _y : datas[Shader3D.BLEND_EQUATION_ALPHA])) !== null && _z !== void 0 ? _z : RenderState.Default.blendEquationAlpha;
                var srcRGB = (_1 = ((_0 = renderState.srcBlendRGB) !== null && _0 !== void 0 ? _0 : datas[Shader3D.BLEND_SRC_RGB])) !== null && _1 !== void 0 ? _1 : RenderState.Default.srcBlendRGB;
                var dstRGB = (_3 = ((_2 = renderState.dstBlendRGB) !== null && _2 !== void 0 ? _2 : datas[Shader3D.BLEND_DST_RGB])) !== null && _3 !== void 0 ? _3 : RenderState.Default.dstBlendRGB;
                var srcAlpha = (_5 = ((_4 = renderState.srcBlendAlpha) !== null && _4 !== void 0 ? _4 : datas[Shader3D.BLEND_SRC_ALPHA])) !== null && _5 !== void 0 ? _5 : RenderState.Default.srcBlendAlpha;
                var dstAlpha = (_7 = ((_6 = renderState.dstBlendAlpha) !== null && _6 !== void 0 ? _6 : datas[Shader3D.BLEND_DST_ALPHA])) !== null && _7 !== void 0 ? _7 : RenderState.Default.dstBlendAlpha;
                RenderStateContext.setBlend(true);
                RenderStateContext.setBlendEquationSeparate(blendEquationRGB, blendEquationAlpha);
                RenderStateContext.setBlendFuncSeperate(srcRGB, dstRGB, srcAlpha, dstAlpha);
                break;
        }
    }
    uploadRenderStateBlendDepthByMaterial(shaderDatas) {
        var datas = shaderDatas.getData();
        var depthWrite = datas[Shader3D.DEPTH_WRITE];
        depthWrite = depthWrite !== null && depthWrite !== void 0 ? depthWrite : RenderState.Default.depthWrite;
        RenderStateContext.setDepthMask(depthWrite);
        var depthTest = datas[Shader3D.DEPTH_TEST];
        depthTest = depthTest !== null && depthTest !== void 0 ? depthTest : RenderState.Default.depthTest;
        if (depthTest === RenderState.DEPTHTEST_OFF) {
            RenderStateContext.setDepthTest(false);
        }
        else {
            RenderStateContext.setDepthTest(true);
            RenderStateContext.setDepthFunc(depthTest);
        }
        var stencilWrite = datas[Shader3D.STENCIL_WRITE];
        stencilWrite = stencilWrite !== null && stencilWrite !== void 0 ? stencilWrite : RenderState.Default.stencilWrite;
        RenderStateContext.setStencilMask(stencilWrite);
        if (stencilWrite) {
            var stencilOp = datas[Shader3D.STENCIL_Op];
            stencilOp = stencilOp !== null && stencilOp !== void 0 ? stencilOp : RenderState.Default.stencilOp;
            RenderStateContext.setstencilOp(stencilOp.x, stencilOp.y, stencilOp.z);
        }
        var stencilTest = datas[Shader3D.STENCIL_TEST];
        stencilTest = stencilTest !== null && stencilTest !== void 0 ? stencilTest : RenderState.Default.stencilTest;
        if (stencilTest == RenderState.STENCILTEST_OFF) {
            RenderStateContext.setStencilTest(false);
        }
        else {
            var stencilRef = datas[Shader3D.STENCIL_Ref];
            stencilRef = stencilRef !== null && stencilRef !== void 0 ? stencilRef : RenderState.Default.stencilRef;
            RenderStateContext.setStencilTest(true);
            RenderStateContext.setStencilFunc(stencilTest, stencilRef);
        }
        var blend = datas[Shader3D.BLEND];
        blend = blend !== null && blend !== void 0 ? blend : RenderState.Default.blend;
        switch (blend) {
            case RenderState.BLEND_ENABLE_ALL:
                var blendEquation = datas[Shader3D.BLEND_EQUATION];
                blendEquation = blendEquation !== null && blendEquation !== void 0 ? blendEquation : RenderState.Default.blendEquation;
                var srcBlend = datas[Shader3D.BLEND_SRC];
                srcBlend = srcBlend !== null && srcBlend !== void 0 ? srcBlend : RenderState.Default.srcBlend;
                var dstBlend = datas[Shader3D.BLEND_DST];
                dstBlend = dstBlend !== null && dstBlend !== void 0 ? dstBlend : RenderState.Default.dstBlend;
                RenderStateContext.setBlend(true);
                RenderStateContext.setBlendEquation(blendEquation);
                RenderStateContext.setBlendFunc(srcBlend, dstBlend);
                break;
            case RenderState.BLEND_ENABLE_SEPERATE:
                var blendEquationRGB = datas[Shader3D.BLEND_EQUATION_RGB];
                blendEquationRGB = blendEquationRGB !== null && blendEquationRGB !== void 0 ? blendEquationRGB : RenderState.Default.blendEquationRGB;
                var blendEquationAlpha = datas[Shader3D.BLEND_EQUATION_ALPHA];
                blendEquationAlpha = blendEquationAlpha !== null && blendEquationAlpha !== void 0 ? blendEquationAlpha : RenderState.Default.blendEquationAlpha;
                var srcRGB = datas[Shader3D.BLEND_SRC_RGB];
                srcRGB = srcRGB !== null && srcRGB !== void 0 ? srcRGB : RenderState.Default.srcBlendRGB;
                var dstRGB = datas[Shader3D.BLEND_DST_RGB];
                dstRGB = dstRGB !== null && dstRGB !== void 0 ? dstRGB : RenderState.Default.dstBlendRGB;
                var srcAlpha = datas[Shader3D.BLEND_SRC_ALPHA];
                srcAlpha = srcAlpha !== null && srcAlpha !== void 0 ? srcAlpha : RenderState.Default.srcBlendAlpha;
                var dstAlpha = datas[Shader3D.BLEND_DST_ALPHA];
                dstAlpha = dstAlpha !== null && dstAlpha !== void 0 ? dstAlpha : RenderState.Default.dstBlendAlpha;
                RenderStateContext.setBlend(true);
                RenderStateContext.setBlendEquationSeparate(blendEquationRGB, blendEquationAlpha);
                RenderStateContext.setBlendFuncSeperate(srcRGB, dstRGB, srcAlpha, dstAlpha);
                break;
            case RenderState.BLEND_DISABLE:
            default:
                RenderStateContext.setBlend(false);
                break;
        }
    }
    uploadRenderStateFrontFace(shaderDatas, isTarget, invertFront) {
        var _a;
        var renderState = (this._shaderPass).renderState;
        var datas = shaderDatas.getData();
        var cull = datas[Shader3D.CULL];
        if ((this._shaderPass).statefirst) {
            cull = (_a = renderState.cull) !== null && _a !== void 0 ? _a : cull;
        }
        cull = cull !== null && cull !== void 0 ? cull : RenderState.Default.cull;
        var forntFace;
        switch (cull) {
            case RenderState.CULL_NONE:
                RenderStateContext.setCullFace(false);
                if (isTarget != invertFront)
                    forntFace = CullMode.Front;
                else
                    forntFace = CullMode.Back;
                RenderStateContext.setFrontFace(forntFace);
                break;
            case RenderState.CULL_FRONT:
                RenderStateContext.setCullFace(true);
                if (isTarget == invertFront)
                    forntFace = CullMode.Front;
                else
                    forntFace = CullMode.Back;
                RenderStateContext.setFrontFace(forntFace);
                break;
            case RenderState.CULL_BACK:
            default:
                RenderStateContext.setCullFace(true);
                if (isTarget != invertFront)
                    forntFace = CullMode.Front;
                else
                    forntFace = CullMode.Back;
                RenderStateContext.setFrontFace(forntFace);
                break;
        }
    }
}
